/**
 * Storage Initialization
 * Runs once when the app starts
 */

let isInitialized = false;

export const initializeSecureStorage = () => {
  if (isInitialized) {
    return;
  }

  console.log('🔐 Initializing secure storage...');

  try {
    // Storage initialization complete
    // All data now uses sessionStorage
    isInitialized = true;

    console.log('✅ Secure storage initialized successfully');
  } catch (error) {
    console.error('❌ Failed to initialize secure storage:', error);
  }
};

export default initializeSecureStorage;
